export default __webpack_public_path__ + "static/media/component_template.74fff6e2.xlsx";